// Modules
import { Table as ANTtable, Pagination as ANTPagination } from "antd";
import { useLocation } from "react-router-dom";

// Hooks
import { useExpandedRowTable } from "components/atoms/ExpandedRowTable/useExpandedRowTable";
import { useExpandedRowTableForRetroClaim } from "components/atoms/ExpandedRowTable/useExpandedRowTableForRetroClaim";
import { useExpandedRowTableForReimVerification } from "components/atoms/ExpandedRowTable/useExpandedRowTableForReimVerification";
import { useExpandedRowTableForReimDeclaration } from "components/atoms/ExpandedRowTable/useExpandedRowTableForReimDeclaration";
import { useExpandedRowTableForAccountManagement } from "components/atoms/ExpandedRowTable/useExpandedRowTableForAccountManagement";

// Types
import { UserDetail } from "containers/RoleManagement/useRoleManagement";
import { useState } from "react";

export type ColumnHeaderRowType = {
	title: React.ReactNode;
	dataIndex: string | string[];
	align?: "left" | "right" | "center";
	width?: string | number;
	render?: () => React.ReactNode;
	fixed?: any;
	key?: string;
};

export type MonthlyDeclarationTableContentType = {
	key: string;
	dateTime: string;
	purchaseValue: string;
	receiptNum: string;
	eVoucherNum: string;
	eVoucherValue: string;
	eVoucherQty: string;
	eVoucherType: string;
};

export type TableDataType = {
	[key: string]: string;
};
export type PageSizeType = {
	[key: string]: number;
};
type UserType = {
	record_count: number;
	user_list: Array<UserDetail>;
};
export type UserListType = {
	[key: string]: UserType;
};

export type GroupDetailsType = {
	[key: string]: any;
};

export type ExpandedRowTableProps = {
	columnHeaderData?: Array<ColumnHeaderRowType>; // Type for column headers
	tableData?: Array<TableDataType>; // Use || to add additional Table Data types
	rowsPerPage?: number;
	handlePagination?: (page: number, groupCode: string) => void;
	groupDetails?: GroupDetailsType;
	searchUser?: string;
	searchTenantCode?: string;
	filterValues?: Array<string>;
	record?: any;
};

type ComponentProps = {
	handlePagination: (pageNumber: number, groupCode: GroupDetailsType) => void;
	handlePaginationWithRecord: (pageNumber: number, record: any) => void;
	updatedList: any;
	loading?: number;
	pageSize: PageSizeType;
	totalRecordCount?: number;
	currentPage?: number;
};

const ExpandedRowTable = ({ columnHeaderData, groupDetails, searchUser, record, tableData, searchTenantCode }: ExpandedRowTableProps) => {
	const [page, setPage] = useState<number>(1);

	const { pathname } = useLocation();
	const componentMap: any = {
		"role-management": useExpandedRowTable,
		"retro-claim": useExpandedRowTableForRetroClaim,
		"declaration-verification": useExpandedRowTableForReimVerification,
		"monthly-declarations": useExpandedRowTableForReimDeclaration,
		"declaration-approval": useExpandedRowTableForReimVerification,
		"account-management": useExpandedRowTableForAccountManagement
	};
	const componentProps: ComponentProps = componentMap[pathname.substring(1, pathname.length)]({ groupDetails, searchUser, record, searchTenantCode });
	const { handlePagination, updatedList, loading, pageSize, totalRecordCount, handlePaginationWithRecord, currentPage } = componentProps;

	const additionalProps = groupDetails ? {} : { current: currentPage };
	return (
		<div className="expanded_row_table">
			<ANTtable loading={loading === 1} columns={columnHeaderData} dataSource={tableData ? tableData : updatedList} pagination={false} scroll={{ y: 900, x: 800 }} />
			<div className="flex justify-end p-4 admin-portal-custom-pagination">
				<ANTPagination
					className="ml-auto"
					current={page}
					{...additionalProps}
					pageSize={typeof pageSize === "number" ? pageSize : groupDetails && pageSize[groupDetails.group_code]}
					total={totalRecordCount}
					showQuickJumper
					showSizeChanger={false}
					onChange={(newPage) => {
						setPage(newPage);
						if (groupDetails) {
							handlePagination(newPage, groupDetails);
						} else {
							handlePaginationWithRecord(newPage, record);
						}
					}}
				/>
			</div>
		</div>
	);
};

export default ExpandedRowTable;
